import { LanguageService, UserService } from '@/services';
import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SpinnerButtonConfig } from '@/ui/spinner-button/spinner-button-config';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorService } from 'src/app/services/error/error.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { StoreService } from 'src/app/services/store/store.service';

@Component({
    selector: 'app-voucher-dialog',
    templateUrl: './voucher-dialog.component.html',
    styleUrls: ['./voucher-dialog.component.scss'],
    standalone: false
})
export class VoucherDialogComponent implements OnInit {
  voucherFormControl = new FormControl<string>('', [Validators.required]);

  schoolYearStart: number;
  schoolYearEnd: number;
  voucherPrice: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private errorService: ErrorService,
    private router: Router,
    private dialogRef: MatDialogRef<VoucherDialogComponent>,
    private notificationService: NotificationService,
    private datePipe: DatePipe,
    private storeService: StoreService,
    private languageService: LanguageService,
    private userService: UserService
  ) {
    this.btnConfig.text = this.languageService.translateWithCap('vouchers.dialog.redeem');
    this.buyBtnConfig.text = this.languageService.translateWithCap('vouchers.dialog.buy-voucher');
  }

  ngOnInit(): void {
    this.getCurrentSchoolYear();
    this.getVoucherPrice();
  }

  getCurrentSchoolYear() {
    this.storeService.getCurrentSchoolYear(this.data.tenant).subscribe({
      next: d => {
        this.schoolYearStart = +d.split('-')[0];
        this.schoolYearEnd = +d.split('-')[1];
      },
      error: e => {
        this.errorService.onError(e);
      },
    });
  }

  getVoucherPrice() {
    this.storeService.getVoucherPrice(this.data.tenant).subscribe({
      next: d => {
        this.voucherPrice = parseFloat(d.replace(',', '.')).toFixed(2).replace('.', ',');
      },
      error: e => {
        this.errorService.onError(e);
      },
    });
  }

  btnConfig: SpinnerButtonConfig = {
    text: `Inwisselen`,
  };
  buyBtnConfig: SpinnerButtonConfig = {
    text: `Voucher kopen`,
  };

  createPayment() {
    this.buyBtnConfig.loading = true;
    let description = this.languageService.translate('vouchers.dialog.payment-description', {
      START: this.datePipe.transform(new Date(this.schoolYearStart), 'dd-MM-yyyy'),
      END: this.datePipe.transform(new Date(this.schoolYearEnd), 'dd-MM-yyyy'),
      REF: this.data.tenant,
    });
    this.storeService
      .createPayment(this.data.tenant, description, +this.voucherPrice.replace(',', '.'), this.data.userId)
      .subscribe({
        next: (d: any) => {
          this.buyBtnConfig.loading = false;
          window.location.href = d.checkoutUrl;
        },
        error: e => {
          this.buyBtnConfig.loading = false;
          this.errorService.onError(e);
        },
      });
  }

  save() {
    this.btnConfig.loading = true;
    this.storeService.redeemVoucher(this.data.tenant, this.voucherFormControl.value!, this.data.userId).subscribe({
      next: d => {
        this.btnConfig.loading = false;
        switch (d.code) {
          case 'VOU_001':
            this.notificationService.success(
              this.languageService.translateWithCap('vouchers.dialog.notifications.you-can-now-login'),
              this.languageService.translateWithCap('vouchers.dialog.notifications.activated')
            );
            this.dialogRef.close();
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigateByUrl('/login');
            });
            break;
          case 'VOU_002':
            this.notificationService.warning(
              this.languageService.translateWithCap('vouchers.dialog.notifications.active-per', {
                DATE: this.datePipe.transform(new Date(d.data), 'dd-MM-yyyy'),
              }),
              this.languageService.translateWithCap('vouchers.dialog.notifications.activated')
            );
            this.dialogRef.close();
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigateByUrl(`/login`);
            });
            break;
          case 'VOU_010':
            this.notificationService.error(
              this.languageService.translateWithCap('vouchers.dialog.notifications.invalid')
            );
            break;
          case 'VOU_011':
            this.notificationService.error(
              this.languageService.translateWithCap('vouchers.dialog.notifications.already-active')
            );
            break;
        }
      },
      error: (e: any) => {
        this.errorService.onError(e);
        this.btnConfig.loading = false;
      },
    });
  }
}
